import utility from '@/shared/utility';

export default class Activity {
  static objectDefinition() {
    return {
      name: '',
      time: '',
      date: '',
      orderId: '',
      activityId: '',
      eventId: -1,
      picture: '',
      month: '',
      locationName: '',
      note: '',
      orderItems: [],
      reviewed: false,
      status: '',
    };
  }

  static parseActivity(activity) {
    const object = this.objectDefinition();

    object.name = activity.Name;
    object.time = `${activity.StartTime}-${activity.EndTime}`;
    object.date = activity.StartDate;
    object.orderId = activity.OrderId;
    object.activityId = activity.UniqueId;
    object.eventId = activity.EventId;
    object.picture = activity.PictureUrl;
    object.locationName = activity.LocationName;
    object.note = activity.Note;
    object.orderItems = activity.OrderItems;
    object.reviewed = activity.Reviewed;
    object.status = activity.Status;

    const today = utility.currentDateNumber();
    const activityDate = utility.dateToNumber(object.date);

    if (activityDate >= today) {
      // console.log("it's bigger")
    } else {
      // console.log("it's smaller")
      object.status = 'Done';
    }
    // console.log("today", today)
    // console.log("activityDate", activityDate)

    if (object.date.split('-').length > 2) {
      const m = Number(object.date.split('-')[1]) - 1;
      object.month = utility.months[m];
    } else {
      console.log("couldn't split date", object.date);
    }

    return object;
  }
}
